// comscore functionality
export function comscore() {
  setTimeout(() => {
    const element: any = document.getElementById('comscore');
    if (element) {
      element.parentNode.removeChild(element);
    }
    // eslint-disable-next-line
    // const _comscore: any = _comscore || [];
    const _comscore: any = [];
    _comscore.push({
      c1: process.env.COMSCORE_C1,
      c2: process.env.COMSCORE_C2
    });
    (function () {
      const s: any = document.createElement('script');
      const el: any = document.getElementsByTagName('script')[0];
      s.async = true;
      s.src = process.env.COMSCORE_URL;
      s.setAttribute('id', 'comscore');
      s.onload = (event: any) => comscorePageView(event);
      el.parentNode.insertBefore(s, el);
    })();
  }, 0);
}

export function comscorePageView(event: any) {
  if (
    typeof window !== 'undefined' &&
    window.COMSCORE &&
    window.COMSCORE.beacon
  ) {
    window.COMSCORE.beacon({
      c1: process.env.COMSCORE_C1,
      c2: process.env.COMSCORE_C2
    });
    // Dummy call to get "pageview_candidate" for comscore.
    if (!event) {
      fetch(
        `${window.location.origin}/comscorePageView.txt?${new Date().getTime()}`
      );
    }
  }
}
